import $http from '$http'
import {
    util
} from 'utils';
import {
    lg
} from 'utils';

export default {
    methods: {
        //POST /api/NewAgent/NewCustomerAdd
        NewCustomerAdd(data) {
            this.loading = true;
            $http.post('api/NewAgent/NewCustomerAdd', data).then(res => {
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '已成功提交转正申请！',
                        type: 'success'
                    });

                    this.$emit('reload-list');
                    this.close();
                });
            });
        },
        // GET /api/NewAgent/GetById
        GetById() {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: this.id
            };

            $http.get('api/NewAgent/GetById', Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    // this.form = Data
                    this.form.Industry_Id = Data.Industry_Id
                    this.form.TimeStamp = Data.TimeStamp
                    this.baseInfo = Data.Customer;
                    this.contact = Data.Contact;
                    this.agentList = Data.List
                    this.contactStorageArea.ProvId = this.contact.ProvId
                    this.contactStorageArea.CityId = this.contact.CityId
                    this.contactStorageArea.AreaId = this.contact.AreaId
                    let len = Data.Customer.ListDoubt.length
                    let $obj = Data.Customer.ListDoubt
                    if (len > 0) {
                        // 含有存疑模块
                        this.isReadOnly = true
                        for (let i = 0; i < len; i++) {

                            switch ($obj[i].Module) {
                                case 1:
                                    // 公司信息
                                    this.conpanyInfoReadOnly = false
                                    break;
                                case 2:
                                    // 主联系人信息
                                    this.contactInfoReadOnly = false
                                    break;
                                case 3:
                                    // 合作信息
                                    this.coopInfoReadOnly = false
                                    break;
                            }

                        }
                    } else {
                        this.coopInfoReadOnly = false
                        this.contactInfoReadOnly = false
                        this.conpanyInfoReadOnly = false
                    }
                    console.log(this.conpanyInfoReadOnly && this.isReadOnly)

                });
            });
        },
        // 修改提交POST /api/NewAgent/NewCustomerModify
        NewCustomerModify(data) {
            this.loading = true;
            data.Id = this.id
            $http.post('api/NewAgent/NewCustomerModify', data).then(res => {
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });

                    this.$emit('reload-list');
                    this.close();
                });
            });
        },


    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/apply-dialog/services.js